import React, { useState } from 'react';
import '../../App.css'
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import { Button, Layout, Menu, theme } from 'antd';
import { images } from '../Assets/ImagesExports/ImageExport';
import { Outlet } from 'react-router-dom';
import Instructor_Navbar from './Instructor_Navbar';
import { Link } from 'react-router-dom';

const { Header, Sider, Content } = Layout;


const DashboardSidebar = () => {
    const [collapsed, setCollapsed] = useState(false);
    const {
        token: { colorBgContainer, borderRadiusLG },
      } = theme.useToken();
  return (
    <div>
        <Instructor_Navbar />
        <Layout style={{padding:'30px'}}>
            <Sider trigger={null} collapsible collapsed={collapsed} style={{ background: 'white'}}>
                <div className="demo-logo-vertical" />
                <div className="user_icon_section p-20">
                    <img
                      src={images.broken_instructor_jpg}
                      alt="profile icon"
                      className="navbar_user_icon"
                    />
                    <p>ravi</p>                         
                </div>
                <Menu
                theme="light"
                mode="inline"
                defaultSelectedKeys={['1']}
                items={[
                    
                    {
                        key: '1',
                        icon: <UserOutlined />,
                        label: (
                            <Link to={'/user/dashboard'}>Dashboard</Link>
                        )
                    },
                    {
                        key: '2',
                        icon: <VideoCameraOutlined />,
                        label:(
                            <Link to={'/user/course_manager'}>Course manager</Link>
                        ) 
                    },
                    {
                        key: '3',
                        icon: <UploadOutlined />,
                        label:(
                            <Link to={'/user/sales_report'}>Sales report</Link>
                        ) 
                    },
                    {
                        key: '4',
                        icon: <UploadOutlined />,
                        label:(
                            <Link to={'/user/payout_report'}>Payout report</Link>
                        ) 
                    },
                    {
                        key: '5',
                        icon: <VideoCameraOutlined />,
                        label:(
                            <Link to='/home/payout_settings'>Payout Settings</Link>
                        ) 
                    },
                    {
                        key: '6',
                        icon: <VideoCameraOutlined />,
                        label:(
                            <Link to='/user/zoom_live_settings'>Zom live settings</Link>
                        )
                    },
                    {
                        key: '7',
                        icon: <VideoCameraOutlined />,
                        label:(
                            <Link to={'/home/message'}>Message</Link>
                        ) 
                    },
                    {
                        key: '8',
                        icon: <VideoCameraOutlined />,
                        label:(
                            <Link to={'/home/profile'}>Manage profile</Link>
                        ) 
                    }
                ]}
                />
            </Sider>
            <Layout>
                {/* <Header
                style={{
                    padding: 0,
                    background: colorBgContainer,
                }}
                >
                <Button
                    type="text"
                    icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                    onClick={() => setCollapsed(!collapsed)}
                    style={{
                    fontSize: '16px',
                    width: 64,
                    height: 64,
                    }}
                />
                </Header> */}
                <Content
                style={{
                    margin: '0px 0px 0px 15px',
                    padding: 24,
                    minHeight: 280,
                    borderRadius: borderRadiusLG,
                    
                }}
                >
                 <Outlet />
                </Content>
            </Layout>
        </Layout>
    </div>
  )
}

export default DashboardSidebar
